import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { registerServiceWorker } from './utils/pwa';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// For Web Push (and keeping the shell loading offline). Production only. Not for installing the
// app — that is StockFlowArka-Setup.exe's job; see utils/pwa.js.
registerServiceWorker();
